import React, { useEffect, useState } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap'
import reactStringReplace from 'react-string-replace'
import * as Icons from "react-feather";
import AddLead from './AddLead';
import DeleteClientCompanyType from './DeleteLead';
import LeadModel from './models/LeadModel';
import EditLead from './EditLead';
import ViewLead from './ViewLead';
import DeleteLead from './DeleteLead';
import ConvertLead from './ConvertLead';

function LeadModal({onClose, onSubmit, UserAction, show, selectedRow}) {
    const [childData, setChildData] = useState(new LeadModel() || []);
    let modalAction;
    let showButtons;
    let userAction = reactStringReplace(UserAction, 'User', () => '');

    useEffect(() => {
        if (show && selectedRow) {
          setChildData({ ...selectedRow }); // create a new object to break reference
        } else if (!show) {
          setChildData(new LeadModel()); // reset when closed
        }
    }, [selectedRow, show]);

    const handleDataFromChild = (data) => {
        setChildData(data);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(e, childData);  // Send the form data back to the parent component
    };

    const handleLoad = (data) => {
        setChildData(data); // Send the form data back to the parent component
    };
    if(UserAction === "Add"){
        modalAction = <AddLead  onLoad= {handleLoad} sendDataToParent={handleDataFromChild}/>
        showButtons = <div>
                            <button className="btn btn-cancel me-2" name="Add" onClick={onClose}>Cancel</button>
                            <button className="btn btn-submit" name="Add" onClick={handleSubmit}> Submit </button>
                    </div>
    } else if(UserAction === "Edit"){
        modalAction = <EditLead LeadData={childData} onSubmit= {onSubmit} sendDataToParent={handleDataFromChild}/>
        showButtons = <div>
                            <button className="btn btn-cancel me-2" name="Edit" onClick={onClose}>Cancel</button>
                            <button className="btn btn-submit" name="Edit" onClick={handleSubmit}> Submit </button>
                    </div>
    } else if(UserAction === "View"){
        modalAction = <ViewLead LeadData={selectedRow}/>
        showButtons = <div>
                            <button className="btn btn-cancel me-2" name="View" onClick={onClose}>Cancel</button>
                    </div>
    } else if (UserAction === "Delete") {
        modalAction = <DeleteLead LeadData={selectedRow} />; // ✅ changed prop name
        showButtons = (
            <div>
            <button className="btn btn-sm btn-secondary m-1" name="Delete" onClick={onClose}>
                Cancel
            </button>
            <button className="btn btn-sm btn-danger m-1" name="Delete" onClick={handleSubmit}>
                Delete
            </button>
            </div>
        );
    } else if (UserAction === "ConvertLead") {
         modalAction = <ConvertLead LeadData={selectedRow} />; // ✅ changed prop name
         showButtons = (
             <div>
             <button className="btn btn-sm btn-secondary m-1" name="ConvertLead" onClick={onClose}>
                 Cancel
             </button>
             <button className="btn btn-sm btn-submit" name="ConvertLead" onClick={handleSubmit}>
                 Confirm
             </button>
             </div>
         );
     }
  return (
    UserAction !== "Delete" && UserAction !== "ConvertLead"?
            <Modal
                show={show}
                onHide={onClose}
                backdrop="static">
                <ModalHeader className="modal-header border-0 custom-modal-header" closeButton>
                    <ModalTitle >{userAction} Lead</ModalTitle>
                </ModalHeader>
                <ModalBody>
                    {modalAction}
                </ModalBody>
                <ModalFooter className="">
                    {showButtons}
                </ModalFooter>
            </Modal> 
        : UserAction === "ConvertLead" ? 
            <Modal
                show={show}
                onHide={onClose}
                backdrop="static">
           
                <ModalHeader className="alert custom-alert1 alert-confirm modalheader-width">
                    <ModalTitle>
                        <div className="custom-alert-icon">
                            <Icons.CheckSquare className="flex-shrink-0"/>
                        </div>
                        <div > Convert lead to client</div>
                    </ModalTitle>
                </ModalHeader>
                <ModalBody>
                    {modalAction}
                </ModalBody>
                <ModalFooter className="modalfooter-width">
                    {showButtons}
                </ModalFooter>
            </Modal>  
        :   <Modal
                show={show}
                onHide={onClose}
                backdrop="static">
                <ModalHeader className="alert custom-alert1 alert-danger modalheader-width">
                    <ModalTitle>
                        <div className="custom-alert-icon">
                            <Icons.AlertOctagon className="flex-shrink-0"/>
                        </div>
                        <div > {userAction} Lead</div>
                    </ModalTitle>
                </ModalHeader>
                <ModalBody>
                    {modalAction}
                </ModalBody>
                <ModalFooter className="modalfooter-width">
                    {showButtons}
                </ModalFooter>
            </Modal>  
  )
}

export default LeadModal;